"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaximumSelectionLength = void 0;
var MaximumSelectionLength = function (target) {
    return /** @class */ (function (_super) {
        __extends(MaximumSelectionLength, _super);
        function MaximumSelectionLength() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MaximumSelectionLength.prototype.binding = function (select, container) {
            var _this = this;
            _super.prototype.binding.call(this, select, container);
            select.on('select', function () {
                _this._checkIfMaximumSelected();
            });
        };
        MaximumSelectionLength.prototype.query = function (params, callback) {
            var _this = this;
            this._checkIfMaximumSelected(function () {
                _super.prototype.query.call(_this, params, callback);
            });
        };
        MaximumSelectionLength.prototype._checkIfMaximumSelected = function (_, successCallback) {
            var _this = this;
            this.maximumSelectionLength = this.options.get('maximumSelectionLength');
            this.current(function (currentData) {
                var count = currentData != null ? currentData.length : 0;
                if (_this.maximumSelectionLength > 0 && count >= _this.maximumSelectionLength) {
                    _this.trigger('results:message', {
                        message: 'maximumSelected',
                        args: {
                            maximum: _this.maximumSelectionLength
                        }
                    });
                    return;
                }
                if (successCallback) {
                    successCallback();
                }
            });
        };
        return MaximumSelectionLength;
    }(target));
};
exports.MaximumSelectionLength = MaximumSelectionLength;
//# sourceMappingURL=maximum-selection-length.js.map